import { ID } from 'shared/types/id';

// null = never seeded, which the tracker treats as "seed silently" rather than "nothing connected".
export const externalCalendarConnectedIdsKeyPrefix =
  'griply.external-calendar-connected-ids.';

export const getExternalCalendarConnectedIds = (key: string): ID[] | null => {
  try {
    const raw = window.localStorage.getItem(key);
    if (raw === null) {
      return null;
    }
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as ID[]) : [];
  } catch {
    return null;
  }
};

export const setExternalCalendarConnectedIds = (key: string, ids: ID[]) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(ids));
  } catch {
    // Private mode / quota exceeded: skip persisting rather than breaking the render.
  }
};
